import type { Item } from '../types/interfaces';

export interface MerchantStockEntry {
  item: Item;
  buy_price: number;
  /** true = a Mercadora vende sem limite. */
  unlimited: boolean;
  /** Unidades em estoque (null quando ilimitado). */
  stock_qty: number | null;
}

export interface MerchantSellEntry {
  item: Item;
  quantity: number;
  sell_price: number;
  /** Vendido aqui, o item entra no estoque da Mercadora e fica à venda. */
  restocks: boolean;
}

export interface MerchantState {
  stock: MerchantStockEntry[];
  sellable: MerchantSellEntry[];
  /** Saldo "Ta Feito" — a mesma moeda da barra do topo e da Forja. */
  balance: number;
  capacity: number;
  bagCount: number;
}

export interface MerchantTxResult {
  success: boolean;
  balance: number;
  bagCount: number;
  earned?: number;
  spent?: number;
  /** Compra: estoque restante (null = ilimitado). */
  stock_qty?: number | null;
  /** Venda: unidades que entraram no estoque da Mercadora. */
  restocked?: number;
}

async function req<T>(url: string, token: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((body as any).error ?? `HTTP ${res.status}`);
  return body as T;
}

export const merchantApi = {
  state: (token: string) => req<MerchantState>('/api/user/merchant', token),

  buy: (token: string, itemId: string, quantity: number) =>
    req<MerchantTxResult>('/api/user/merchant/buy', token, {
      method: 'POST',
      body: JSON.stringify({ item_id: itemId, quantity }),
    }),

  sell: (token: string, itemId: string, quantity: number) =>
    req<MerchantTxResult>('/api/user/merchant/sell', token, {
      method: 'POST',
      body: JSON.stringify({ item_id: itemId, quantity }),
    }),
};
